import React from "react";
import styled from "styled-components";

const CardText = (props) => {
  const { image, title, detail, link, colorText, link1, link2, link3 } = props;

  return (
    <Card color={colorText}>
      <img
        src={image}
        alt="view"
        style={{ width: "100%", borderRadius: "20px" }}
        loading="lazy"
      />
      <Container>
        <Title>{title}</Title>
        <Detail>{detail}</Detail>

        {link && (
          <div className="link-web">
            <a
              className="link-web"
              href={link}
              target="_blank"
              rel="noreferrer"
            >
              <u>ดูข้อมูลเพิ่มเติม</u>
            </a>
          </div>
        )}
        {link1 && link2 && link3 && (
          <p className="link-web" style={{ marginBottom: "0" }}>
            ไปยังเว็บ{" "}
            <a href={link1} target="_blank" rel="noreferrer">
              <u>ส่วนกิจการนักศึกษา,</u>
            </a>{" "}
            <a href={link2} target="_blank" rel="noreferrer">
              <u>ทุนการศึกษา,</u>
            </a>{" "}
            <a href={link3} target="_blank" rel="noreferrer">
              <u>หอพักนักศึกษา</u>
            </a>
          </p>
        )}
      </Container>
    </Card>
  );
};

export default CardText;

export const Card = styled.div`
  width: 100%;
  height: 100%;
  color: var(--black);

  .link-web {
    display: block;
    color: ${(props) => (props.color ? props.color : "var(--black)")};
    text-align: left;
    font-family: "Noto Sans Thai";
    line-height: 35px;
    font-size: clamp(22px, 2vw, 30px);
    margin-left: 0;

    a {
      color: ${(props) =>
        props.color ? props.color : "var(--black)"} !important;
      margin-left: 0;

      &:hover {
        color: var(--secondary) !important;
      }
    }
  }
`;

export const Container = styled.div`
  padding: 20px 0;
`;

export const Title = styled.p`
  font-family: "Noto Sans Thai";
  line-height: 35px;
  font-size: clamp(22px, 2vw, 30px);
  text-align: left;
  margin: 0;
`;

export const Detail = styled.p`
  font-family: "Noto Sans Thai";
  line-height: 35px;
  font-size: clamp(22px, 2vw, 30px);
  text-align: left;
  margin: 0;
`;
